import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IClearSavedPasswordsParams {
}

export interface IClearSavedPasswordsResult {
}

export class ClearSavedPasswordsRequest extends Request<IClearSavedPasswordsParams, IClearSavedPasswordsResult> {
  constructor(params: IClearSavedPasswordsParams = {}) {
    super('clearSavedPasswords', params);
  }
}
